export const targets = [
	{ selector: "[data-faq='glossary']" },
	{ selector: "[data-faq='normal']" },
] as const;

/**
 * Initializes the FAQ plugin by checking for the presence of target elements
 * and loading the appropriate React components.
 */
export async function init(): Promise<void> {
	for (const target of targets) {
		const element = document.querySelector(target.selector);
		if (element) {
			const e = await import("./loader.js");
			e.default();
			break;
		}
	}
}
void init();
